import { useEffect } from 'react'
import { useQuery, QueryObserverResult } from '@tanstack/react-query'
import { getCompanyPrefillData } from '@pepper/utils/src/api/users/users'

import { useShowMessage } from '../providers'

type ReturnType = {
  data: Prefillbiodata | null | undefined
  isLoading: boolean
  isFetching: boolean
  error: Error | null
  refetch: () => Promise<QueryObserverResult<Prefillbiodata | null | undefined>>
}

export const useCompanyPrefillData = (index: any, id: string): ReturnType => {
  const showMessage = useShowMessage()

  const handleApiRequest = async () => {
    const {
      status,
      data: _data,
      error: _error
    } = await getCompanyPrefillData(id)
    if (status === 'ok') {
      return _data
    } else {
      throw new Error(_error)
    }
  }

  const { isLoading, isFetching, isError, data, refetch, error } = useQuery<
    Prefillbiodata | null,
    Error
  >({
    queryKey: [index],
    queryFn: handleApiRequest,
    enabled: index ? true : false
  })

  useEffect(() => {
    if (isError) {
      showMessage({ type: 'error', message: error?.message })
    }
  }, [isError, error, showMessage])

  return { data, isLoading, isFetching, error, refetch }
}
